import React      from 'react';
import PropTypes  from 'prop-types';
import classNames from 'classnames';

import './bordered_box.scss';

const BorderedBox = ({ disabled, className, children }) => {
  return (
    <div className={ classNames('bordered-box', className, { disabled }) }>
      { children }
    </div>
  );
};

BorderedBox.defaultProps = {
  disabled:  false,
  className: '',
};

BorderedBox.propTypes = {
  disabled:  PropTypes.bool,
  children:  PropTypes.any.isRequired,
  className: PropTypes.string,
};

export default BorderedBox;
